export default {
  subheader: {
    fontSize: 20,
    fontWeight: 300,
    fontFamily: '"Helvetica Neue",Helvetica,Arial,sans-serif',
    paddingLeft: 8,
    paddingRight: 8,
    marginTop: 8,
  },
  content: {
    maxWidth: 600,
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  loading: {
    padding: 16,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 16,
  },
  label: {
    color: 'rgba(0, 0, 0, 0.3)',
    fontSize: '12px',
  },
  buttonStyle: {
    background: 'transparent',
    border: 'none',
    padding: '8px',
    marginLeft: '16px',
    cursor: 'pointer',
  },
  row: {
    alignItems: 'flex-start',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
    padding: '16px 24px',
  },
  alignRight: {
    textAlign: 'right',
  },
  col1: {
    width: '15%',
  },
  col2: {
    width: '40%',
  },
  col3: {
    width: '20%',
  },
  col4: {
    width: '15%',
  },
};



// WEBPACK FOOTER //
// ./src/containers/pay/styles/Cards.js